import { VacinacaoGrupoConsolidadoFragment } from 'graphql/types.generated'
import { chain } from 'lodash'
import { isUndefinedOrNull } from 'util/checks'
import { formatDate } from 'util/date/formatDate'
import { HOJE, humanizeDate } from 'util/date/humanize-date'

export function formatVacinasAplicadasConsolidado(vacinas: VacinacaoGrupoConsolidadoFragment['vacinas']): string[] {
  if (isUndefinedOrNull(vacinas) || vacinas.isEmpty()) {
    return []
  }

  return chain(vacinas)
    .sortBy((vacina) => vacina.ordem)
    .groupBy((vacina) => vacina.dose)
    .map((vacinasDose, dose) => {
      const imunosFormatados = chain(vacinasDose)
        .sortBy((vacina) => vacina.dataAplicacao)
        .map((vacina) => `${formatDate(vacina.dataAplicacao)} - ${vacina.nome} (${vacina.sigla})`)
        .join(' | ')
        .value()
      return `${dose} - ${imunosFormatados}`
    })
    .value()
}

export const humanizedDateAcompanhamentoCondicaoSaude = (
  dataNascimento: LocalDate,
  dataPrimeiraConsulta: LocalDate
) => {
  if (isUndefinedOrNull(dataNascimento) || isUndefinedOrNull(dataPrimeiraConsulta)) {
    return ''
  }

  const humanized = humanizeDate(dataNascimento, dataPrimeiraConsulta)
  return humanized === HOJE ? 'Recém-nascido' : humanized
}
